import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnnouncementService, BalanceQuery, config, MemberDetails, MemberQuery } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  config = config;
  pointsBalance$: Observable<number | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;

  showTopMenu: boolean = false;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    this.showTopMenu = scrollY > 315;
  }

  constructor(
    private announcementService: AnnouncementService,
    private router: Router,
    private memberQuery: MemberQuery,
    private balanceQuery: BalanceQuery
  ) {}

  ngOnInit() {
    this.announcementService.fetchAnnouncements().toPromise();
    this.pointsBalance$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
  }

  navigateToAccount() {
    this.router.navigate(['/account']);
  }
}
